import { render, staticRenderFns } from "./ZeroHero.vue?vue&type=template&id=092c32f3&"
import script from "./ZeroHero.vue?vue&type=script&lang=js&"
export * from "./ZeroHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports